/* ============================================================
   AutoLens — PDP top gallery
   Swipeable product photos with dots + 4s autoplay.
   Loaded by sections/autolens-pdp-top.liquid; the preview
   artifact inlines this same file so there is one source.

   Position is read and set from rendered geometry rather than
   from scrollLeft: RTL scrollers disagree across browsers about
   whether scrollLeft runs negative, and a delta measured off
   getBoundingClientRect is correct either way.
   ============================================================ */
(function () {
  'use strict';

  var INTERVAL = 4000;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(track) {
    var media = track.closest('.al-pdptop__media');
    if (!media) return;

    var dots = [].slice.call(media.querySelectorAll('.al-pdptop__dot'));
    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;

    var timer = null;
    var stopped = reduced;

    // how far slide i sits from the track's leading edge, in px
    function offsetOf(i) {
      return slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
    }

    function current() {
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(offsetOf(i));
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function goTo(i, instant) {
      var n = (i + slides.length) % slides.length;
      var delta = offsetOf(n);
      if (!delta) return;
      // the track's CSS sets scroll-behavior:smooth, and 'auto' defers to it —
      // only an explicit 'instant' really skips the animation
      track.scrollBy({ left: delta, behavior: instant ? 'instant' : 'smooth' });
    }

    function paintDots() {
      var i = current();
      for (var n = 0; n < dots.length; n++) {
        if (n === i) { dots[n].setAttribute('aria-current', 'true'); }
        else { dots[n].removeAttribute('aria-current'); }
      }
    }

    function advance() {
      // read the settled position each tick rather than tracking an index,
      // so a swipe mid-cycle can never leave the timer out of step
      var next = current() + 1;
      // wrapping back to the first shot jumps instead of rewinding past all of them
      goTo(next, next >= slides.length);
    }

    function play() {
      if (stopped || timer) return;
      timer = setInterval(advance, INTERVAL);
    }
    function pause() {
      clearInterval(timer);
      timer = null;
    }
    function surrender() {   // visitor took control — leave the photos alone
      stopped = true;
      pause();
    }

    track.addEventListener('scroll', paintDots, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, surrender, { passive: true });
    });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { surrender(); goTo(n); });
    });

    // only cycle while the gallery is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { play(); } else { pause(); }
        });
      }, { threshold: 0.4 }).observe(media);
    }
    if (!document.hidden) play();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { pause(); } else { play(); }
    });

    paintDots();
  }

  function init() {
    document.querySelectorAll('.al-pdptop__track').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
